<template>
  <div class="customselect">
    <div v-if="name" class="label">{{ name }}</div>
    <div
      class="mock-select"
      v-if="selectedItems.length > 0"
      @click="open = !open"
      :id="'customselect-mock-select-'+name"
      :class="[{invalid: !validationResult}, size]"
    >
      <div :class="[chip ? 'chip' : 'no-chip' ]" :id="sanitizeId('chip-'+name)">
        {{ transPath ? $t(`${transPath}.${selectedItems[0].key}`) : $t(`${selectedItems[0].key}`) }}
      </div>
      <div class="chip" v-if="selectedItems.length > 1">
        +{{ (selectedItems.length - 1) }}
      </div>
      <v-icon v-if="open" class="icon" icon="mdi-chevron-up" color="primary"></v-icon>
      <v-icon v-else class="icon" icon="mdi-chevron-down" color="primary"></v-icon>
    </div>
    <div
      v-else
      class="mock-select"
      @click="open = !open"
      :id="this.sanitizeId('#customselect-mock-select-'+name)"
      :class="[{invalid: !validationResult}, size]"
    >
      {{$t('select_from_list_label')}}
      <v-icon v-if="open" class="icon" icon="mdi-chevron-up" color="primary"></v-icon>
      <v-icon v-else class="icon" icon="mdi-chevron-down" color="primary"></v-icon>
    </div>
    <div :class="['dropdown', size]" v-if="open"  v-click-outside="checkOutsideClick">
      <div class="favourite" v-if="favourite && favourite.key">
        <div class="sublabel">{{$t('most_popular_sublabel')}}</div>
        <div class="option"
          :name="favourite.key"
          :class="{selected: isSelected(favourite.key)}"
        >
          <label :for="favourite.key" class="checkboxContainer">
            {{ transPath ? $t(`${transPath}.${favourite.key}`) : $t(`${favourite.key}`) }}
            <input
              type="checkbox"
              class="checkbox"
              :name="favourite.key"
              :id="favourite.key" 
              @change="toggle($event,favourite)"
              :checked="isSelected(favourite.key)"
            />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
      <div class="splitter" v-if="favourite && favourite.key"></div>
      <div class="options">
        <div class="sublabel" v-if="favourite && favourite.key">{{$t('rest_sublabel')}}</div>
        <div class="option"
          v-for="(item, index) in (favourite ? options_rest : options)"
          :name="item.key"
          :key="'race'+index"
          :class="{selected: isSelected(item.key)}"
        >
          <label :for="item.key" class="checkboxContainer">{{ transPath ? $t(`${transPath}.${item.key}`) : $t(`${item.key}`) }}
            <input
              type="checkbox"
              class="checkbox"
              :name="item.key"
              :id="item.key" 
              @change="toggle($event,item)"
              :checked="isSelected(item.key)"
            />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import { computed } from "vue";
export default {
  props: {
    modelValue: Array,
    options: Array,
    name: String,
    size: {
      type: String,
      default: ''
    },
    transPath: {
      type: String,
      default: null
    },
    chip: {
      type: Boolean,
      default: true
    },
    validationResult: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      limit: 1,
      open: false,
      favourite: null
    }
  },
  watch: {
    selectedItems() {
      this.adjustEntry();
    }
  },
  setup(props, { emit }) {
    const selectedItems = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });
    const options_rest = computed({
      get: () => Array.from(props.options).sort((a,b) => {return b.doc_count - a.doc_count;}).slice(1),
    });
    return {
      selectedItems,
      options_rest
    };
  },
  mounted() {
    this.favourite = this.flat ? null : Array.from(this.options).sort((a,b) => {return b.doc_count - a.doc_count;})[0];
    this.adjustEntry();
  },
  methods: {
    checkOutsideClick(e){
      if(e.target.id == this.sanitizeId('#customselect-mock-select-'+this.name)) {
        return;
      } else {
        this.open = false;
      }
    },
    toggle(e,item) {
      if(this.multiple) {
        let itemFound = this.selectedItems.find(e => e.key == item.key);
        if(!itemFound) {
          this.selectedItems = this.selectedItems.concat([item]);
        } else {
          this.selectedItems = this.selectedItems.filter(e => e.key != item.key);
        }
      } else {
        if(this.selectedItems[0] && this.selectedItems[0].key == item.key) {
          this.selectedItems = []
        } else {
          this.selectedItems = [item];
        }
        this.open = false;
      }
      // check if selected item fits in mock-select
      this.adjustEntry()
    },
    adjustEntry() {
      this.$nextTick(() => {
        const limiter = this.selectedItems.length > 1 ? 100 : 60;
        let availableLength = document.querySelector(this.sanitizeId('#customselect-mock-select-'+this.name))?.getBoundingClientRect().width - limiter;
        let element = document.querySelector(this.sanitizeId('#chip-'+this.name));
        element?.classList.remove('short');
      
        if (element && element?.getBoundingClientRect().width > availableLength) {
          element.classList.add('short');
        }
      })
    },
    isSelected(key){
      return this.selectedItems.find(e => e.key == key);
    },
    sanitizeId(id) {
      return id.replace(' ','').replace('(','').replace(')','');
    }
  }
  
};
</script>

<style lang="scss" scoped>
.customselect {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border: none;
  width: 100%;
  .label {
    margin-bottom: 4px;
  }
  .mock-select {
    @include nsb-select-placeholder;
    position: relative;
    height: 40px;
    width: 100%;
    padding: 11px 16px;
    background: $ds-white;
    color: $nsb-placeholder;
    border: 1px solid $ds-secondary-300;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
    // &.small {
    //   height: 26px;
    //   padding: 4px 8px;
    //   .icon {
    //     font-size: 22px;
    //     top: 0px;
    //     right: 4px;
    //   }
    // }
    .icon {
      position: absolute;
      color: $ds-primary;
      font-size: 28px;
      top: 6px;
      right: 8px;
    }
    .chip {
      @include nsb-select-chip;
      display: inline-block;
      // height: 26px;
      border-radius: 12px;
      background: $ds-primary;
      padding: 4px 8px;
      margin-right: 16px;
      white-space: nowrap;
      &.short {
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 200px;
      }
    }
    .no-chip {
      @include nsb-select-no-chip;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: calc(100% - 32px);
    }
  }
  .dropdown {
    border: 1px solid #0000001f;
    position: absolute;
    width: 100%;
    top: 64px;
    background: white;
    border-radius: 4px;
    z-index: 10;
    max-height: 200px;
    overflow-y: auto;
    box-shadow: 0px 3px 3px $nsb-color-3;
    &:hover {
      overflow-y: auto;
    }
    &.small {
      top: 32px;
      .option {
        padding: 4px 8px;
      }
    }
    .sublabel {
      @include nsb-select-sublabel;
      margin-top: 12px;
      padding: 0px 16px;
    }
    .option {
      @include nsb-select-option;
      position: relative;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      padding: 8px 16px;
      width: 100%;
      &:hover, &.selected {
        background: $nsb-color-3;
      }
    }
    .splitter {
      display: block;
      height: 1px;
      background: $nsb-color-3;
      width: 100%;
    }
  }
  .invalid {
    border: 1px solid $nsb-alert;
  }
}
// custom scroll for dropdown
// maybe should be global
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $nsb-color-3;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $nsb-color-4;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $nsb-color-4;
}

// custom checkbox for multiiselect
// maybe should be global
/* CUSTOM CHECKBOX */
/* The checkboxContainer */
.checkboxContainer {
  display: block;
  position: relative;
  padding-left: 24px;
  width: 100%;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkboxContainer input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 1px;
  left: 0px;
  height: 14px;
  width: 14px;
  border-radius: 2px;
  border: 1px solid $nsb-color-4;
}

/* On mouse-over, add a grey background color */
.checkboxContainer:hover input ~ .checkmark {
  border-color: $ds-primary;
}

/* When the checkbox is checked, add a blue background */
.checkboxContainer input:checked ~ .checkmark {
  border-color: $ds-primary;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkboxContainer input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkboxContainer .checkmark:after {
  left: 1px;
  top: 1px;
  width: 10px;
  height: 10px;
  background: $ds-primary;
  border-radius: 2px;
}

// @media (min-width: 960px) {
//   .customselect {
//     max-width: 280px;
//   }
// }
</style>